module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1530-9bfc5edae8099003c45e102327daa740.png";